/* Nightpass - carrousels horizontaux (produits similaires, categories) */
(function () {
  function build() {
    var blocks = document.querySelectorAll('.np-carousel');
    for (var b = 0; b < blocks.length; b++) {
      (function (block) {
        var list = block.querySelector('[data-np-list]');
        var head = block.querySelector('.np-carousel-head');
        if (!list || !head || list.getAttribute('data-np-ready')) return;
        list.setAttribute('data-np-ready', '1');

        var nav = document.createElement('div');
        nav.className = 'np-carousel-nav';
        head.appendChild(nav);

        var arrow = '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12h15M13 6l6 6-6 6"/></svg>';
        var prev = document.createElement('button');
        prev.type = 'button';
        prev.className = 'np-carousel-btn np-carousel-btn--prev';
        prev.setAttribute('aria-label', 'Pr\u00e9c\u00e9dent');
        prev.innerHTML = arrow;
        var next = document.createElement('button');
        next.type = 'button';
        next.className = 'np-carousel-btn np-carousel-btn--next';
        next.setAttribute('aria-label', 'Suivant');
        next.innerHTML = arrow;
        nav.appendChild(prev);
        nav.appendChild(next);

        function step() {
          var item = list.querySelector('.np-sim__item');
          if (!item) return list.clientWidth * 0.8;
          var s = window.getComputedStyle(list);
          var gap = parseFloat(s.columnGap || s.gap || '20') || 20;
          return item.getBoundingClientRect().width + gap;
        }
        function sync() {
          var max = list.scrollWidth - list.clientWidth - 2;
          prev.disabled = list.scrollLeft <= 2;
          next.disabled = max <= 2 || list.scrollLeft >= max;
        }
        prev.addEventListener('click', function () { list.scrollBy({ left: -step(), behavior: 'smooth' }); });
        next.addEventListener('click', function () { list.scrollBy({ left: step(), behavior: 'smooth' }); });
        list.addEventListener('scroll', sync, { passive: true });
        window.addEventListener('resize', sync);
        sync();
      })(blocks[b]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else { build(); }
  document.addEventListener('shopify:section:load', build);
})();
